// extracted by mini-css-extract-plugin
export default {"wordsListWrapper":"WordsList_wordsListWrapper__aO6kL","wordsList":"WordsList_wordsList__s8lUs","itemWord":"WordsList_itemWord__-sY+P"};